import { render, staticRenderFns } from "./SpecialLeague.vue?vue&type=template&id=97fd5652&"
import script from "./SpecialLeague.vue?vue&type=script&lang=js&"
export * from "./SpecialLeague.vue?vue&type=script&lang=js&"
import style0 from "./SpecialLeague.vue?vue&type=style&index=0&id=97fd5652&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports